module.exports = __webpack_public_path__ + "img/数据分析.78576be2.png";